/* eslint-disable max-len */
// import AUTO from '../../../../src/assets/autoParts.png';
import CBAM_SECTION1 from '../../../../src/assets/cbamSection1.png';
import CBAM_SECTION2 from '../../../../src/assets/cbamSection2.png';
import CBAM_SECTION3 from '../../../../src/assets/cbamSection3.png';
import CBAM_SECTION4 from '../../../../src/assets/cbamSection4.png';
import CBAM_SECTION5 from '../../../../src/assets/cbamSection5.png';
import CBAM_SECTION6 from '../../../../src/assets/cbamSection6.png';
import CBAM_SECTION7 from '../../../../src/assets/cbamSection7.png';
import ENV from '../../../../src/assets/environmental.png';
import GEN from '../../../../src/assets/general.png';
import GD from '../../../../src/assets/generalDisclosure.png';
import GOV from '../../../../src/assets/governance.png';
import MPD from '../../../../src/assets/manProDis.png';
import MODS from '../../../../src/assets/mods.png';
import PPD from '../../../../src/assets/princiDis.png';
import REAL from '../../../../src/assets/realEstate.png';
import SOC from '../../../../src/assets/social.png';
// import SOFTWARE from '../../../../src/assets/software.png';
import QUES from '../../../assets/ques.png';

import {
  cbamIronAndSteelSubCategories,
  pillarRoutes,
  subCategoryConstants
} from './frameworkRoutes';

export const GRIObject = [
  {
    key: '1',
    icon: GEN,
    title: 'General',
    content: `Pertains to the evaluation criteria measuring a company's
               environmental, social, and governance performance concerning
                sustainable and ethical practices.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Foundation'
      },
      {
        key: '2',
        ptitle: 'Organizational Profile'
      },
      {
        key: '3',
        ptitle: 'Activities and workers'
      },
      {
        key: '4',
        ptitle: 'Governance'
      },
      {
        key: '5',
        ptitle: 'Strategy, policies and practices'
      },
      {
        key: '6',
        ptitle: 'Stakeholder engagement'
      }
    ],
    route: pillarRoutes.GENERAL
  },
  {
    key: '2',
    icon: ENV,
    title: 'Environmental',
    content: `Refers to a company's impact on the environment, 
              encompassing practices related to climate change, 
              resource management, and ecological sustainability.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Materials'
      },
      {
        key: '2',
        ptitle: 'Energy Consumption'
      },
      {
        key: '3',
        ptitle: 'Water and Effluents'
      },
      {
        key: '4',
        ptitle: 'Biodiversity'
      },
      {
        key: '5',
        ptitle: 'Emissions'
      },
      {
        key: '6',
        ptitle: 'Waste Generation & Management'
      },
      {
        key: '7',
        ptitle: 'Compliance'
      },
      {
        key: '8',
        ptitle: 'Supply Chain'
      }
    ],
    route: pillarRoutes.ENV
  },

  {
    key: '3',
    icon: SOC,
    title: 'Social',
    content: `Concerns a company's approach and impact on societal factors,
               including labor practices, diversity, community engagement, and human rights.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Diversity of governance bodies and employees'
      },
      {
        key: '2',
        ptitle: 'Ratio of basic salary and renumeration of women to men'
      },
      {
        key: '3',
        ptitle: 'Employment'
      },
      {
        key: '4',
        ptitle: 'Labour/Management Relations'
      },
      {
        key: '5',
        ptitle: 'Security Practices'
      },
      {
        key: '6',
        ptitle: 'Rights of Indigenous Peoples'
      },
      {
        key: '7',
        ptitle: 'Human Rights Assessment'
      },
      {
        key: '8',
        ptitle: 'Local Communities'
      },
      {
        key: '9',
        ptitle: 'Market Presence'
      },
      {
        key: '10',
        ptitle: 'Freedom of Association and Collective Bargaining'
      },
      {
        key: '11',
        ptitle: 'Non-discrimination'
      },
      {
        key: '12',
        ptitle: 'Child Labor'
      },
      {
        key: '13',
        ptitle: 'Forced Labor'
      },
      {
        key: '14',
        ptitle: 'Occupational Health and Safety'
      },
      {
        key: '15',
        ptitle: 'Work-related injuries'
      },
      {
        key: '16',
        ptitle: 'Work-related ill Health'
      },
      {
        key: '17',
        ptitle: 'Training and Education'
      },
      {
        key: '18',
        ptitle: 'Supplier Social Assessment'
      },
      {
        key: '19',
        ptitle: 'Customer Health and Safety'
      },
      {
        key: '20',
        ptitle: 'Customer Privacy'
      },
      {
        key: '21',
        ptitle: 'Socioeconomic Compliance'
      }
    ],
    route: pillarRoutes.SOCIAL
  },
  {
    key: '4',
    icon: GOV,
    title: 'Governance',
    content: `Focuses on a company's internal controls, leadership structures, transparency, 
              and ethical standards in decision-making and accountability.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Public Policy'
      },
      {
        key: '2',
        ptitle: 'Marketing and Labeling'
      },
      {
        key: '3',
        ptitle: 'Economic Performance'
      },
      {
        key: '4',
        ptitle: 'Indirect Economic Impacts'
      },
      {
        key: '5',
        ptitle: 'Procurement Practices'
      },
      {
        key: '6',
        ptitle: 'Anti-Corruption'
      },
      {
        key: '7',
        ptitle: 'Anti-Competitive Behavior'
      },
      {
        key: '8',
        ptitle: 'Tax'
      }
    ],
    route: pillarRoutes.GOV
  }
];

export const SASBObject = [
  {
    key: '1',
    icon: REAL,
    title: 'Real Estate',
    content: `The Global Reporting Initiative (GRI) framework is a widely used set of guidelines
     for sustainability reporting.
       It helps organizations disclose their social, environmental, and economic impacts transparently.
        GRI enables comprehensive reporting, fostering accountability.
         This framework assists in understanding an organization's sustainability efforts,
       promoting responsible practices.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Energy Management'
      },
      {
        key: '2',
        ptitle: 'Water Management'
      },
      {
        key: '3',
        ptitle: 'Management of Tenant Sustainability Impacts'
      },
      {
        key: '4',
        ptitle: 'Climate Change Adaptation'
      }
    ],
    route: pillarRoutes.REAL_ESTATE,
    category: 1
  }
  // {
  //   key: '2',
  //   icon: SOFTWARE,
  //   title: 'Software & IT Services',
  //   content: `India's Business Responsibility and Sustainability Report (BRSR)—a framework for
  //    environmental, social and governance (ESG) reporting—comes into effect in 2023.
  //     These new reporting standards represent an evolution from
  //   the voluntary guidelines first issued in 2009 by India's Ministry of Corporate Affairs,
  //   which were further refined in the Business Responsibility Report (BRR) of 2012.`,
  //   buttonText: 'Continue',
  //   mods: MODS,
  //   ques: QUES,
  //   modules: 'No. of Modules',
  //   questions: 'Question Answered',
  //   timel: [
  //     {
  //       key: '1',
  //       ptitle: 'Activity Metrics'
  //     },
  //     {
  //       key: '2',
  //       ptitle: 'Environmental Footprint of Hardware Infrastructure'
  //     },
  //     {
  //       key: '3',
  //       ptitle: 'Data Privacy & Freedom of Expression'
  //     },
  //     {
  //       key: '4',
  //       ptitle: 'Data Security'
  //     },
  //     {
  //       key: '5',
  //       ptitle: 'Recruiting & Managing a Global, Diverse & Skilled Workforce'
  //     },
  //     {
  //       key: '6',
  //       ptitle: 'Intellectual Property Protection & Competitive Behaviour'
  //     },
  //     {
  //       key: '7',
  //       ptitle: 'Managing Systematic Risks from Technology Disruptions'
  //     }
  //   ],
  //   route: pillarRoutes.SOFTWARE,
  //   category: 2
  // },
  // {
  //   key: '3',
  //   icon: AUTO,
  //   title: 'Auto Parts',
  //   content: `The Sustainability Accounting Standards Board (SASB) framework offers industry-specific
  //             guidelines for companies to disclose financially material sustainability information.
  //             It focuses on environmental, social, and governance (ESG) factors most relevant to a company's
  //             performance, aiding investors in making informed decisions while promoting transparency and
  //             accountability in corporate reporting.`,
  //   buttonText: 'Continue',
  //   mods: MODS,
  //   ques: QUES,
  //   modules: 'No. of Modules',
  //   questions: 'Question Answered',
  //   timel: [
  //     {
  //       key: '1',
  //       ptitle: 'Energy Management'
  //     },
  //     {
  //       key: '2',
  //       ptitle: 'Water Management'
  //     },
  //     {
  //       key: '3',
  //       ptitle: 'Product Safety'
  //     },
  //     {
  //       key: '4',
  //       ptitle: 'Design for Fuel Efficiency'
  //     },
  //     {
  //       key: '5',
  //       ptitle: 'Materials Sourcing'
  //     },
  //     {
  //       key: '6',
  //       ptitle: 'Materials Efficiency'
  //     },
  //     {
  //       key: '7',
  //       ptitle: 'Competitive Behaviour'
  //     }
  //   ],
  //   route: pillarRoutes.AUTO,
  //   category: 3
  // }
];

export const BRSRObject = [
  {
    key: '1',
    icon: GD,
    title: 'Section A : General Disclosure',
    content: `Focuses on governance-related aspects, encompassing corporate structure, ethics, 
              board composition, and policies shaping sustainable practices and accountability.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Details of the Listed Entity'
      },
      {
        key: '2',
        ptitle: 'Products / Services'
      },
      {
        key: '3',
        ptitle: 'Operations'
      },
      {
        key: '4',
        ptitle: 'Employees'
      },
      {
        key: '5',
        ptitle:
          'Holding, Subsidiary and Associate Companies (including Joint Ventures)'
      },
      {
        key: '6',
        ptitle: 'CSR Details'
      },
      {
        key: '7',
        ptitle: 'Transparency and Disclosures Compliances'
      }
    ],
    route: pillarRoutes.SECTIONA
  },
  {
    key: '2',
    icon: MPD,
    title: 'Section B : Management And Process Disclosures',
    content: `Addresses social factors, including workforce diversity, labor practices, 
              human rights, community engagement, and social impact initiatives.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Policy and management processes'
      },
      {
        key: '2',
        ptitle: 'Governance, Leadership and Oversight'
      }
    ],
    route: pillarRoutes.SECTIONB
  },
  {
    key: '3',
    icon: PPD,
    title: 'Section C : Principle Wise Performance Disclosure',
    content: `Deals with environmental considerations, covering aspects like energy use, emissions, 
              waste management, biodiversity, and overall environmental impact assessments.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Principle 1'
      },
      {
        key: '2',
        ptitle: 'Principle 2'
      },
      {
        key: '3',
        ptitle: 'Principle 3'
      },
      {
        key: '4',
        ptitle: 'Principle 4'
      },
      {
        key: '5',
        ptitle: 'Principle 5'
      },
      {
        key: '6',
        ptitle: 'Principle 6'
      },
      {
        key: '7',
        ptitle: 'Principle 7'
      },
      {
        key: '8',
        ptitle: 'Principle 8'
      },
      {
        key: '9',
        ptitle: 'Principle 9'
      }
    ],
    route: pillarRoutes.SECTIONC
  }
];

export const TCFDObject = [
  {
    key: '1',
    icon: GOV,
    title: 'Governance',
    content: `Clarifies board- and management-level accountability for climate matters, 
      the foundation for all further action.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Governance'
      }
    ],
    route: pillarRoutes.GOV
  },
  {
    key: '2',
    icon: ENV,
    title: 'Strategy',
    content: `Tests business resilience under plausible climate scenarios 
      to inform long-term planning.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Strategy'
      }
    ],
    route: pillarRoutes.STARTEGY
  },

  {
    key: '3',
    icon: SOC,
    title: 'Risk Management',
    content: `Integrates climate-related risks and opportunities into 
    the enterprise risk framework to prevent surprises.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Risk Management'
      }
    ],
    route: pillarRoutes.RISK_MANAGEMENT
  },
  {
    key: '4',
    icon: GEN,
    title: 'Metrics & Targets',
    content: `Establishes quantifiable indicators and deadlines to 
    track and demonstrate progress with credibility.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Metrics & Targets'
      }
    ],
    route: pillarRoutes.MATRICS_TARGETS
  }
];

export const CDPObject = [
  {
    key: '1',
    icon: GOV,
    title: 'SME Introduction',
    content: `This module requests information about the organization’s 
    disclosure to CDP and will help data users interpret responses in the context of 
    the organization’s business operations, timeframe, and entities included in their CDP response. `,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'SME Introduction'
      }
    ],
    route: pillarRoutes.SME_INTRODUCTION
  },
  {
    key: '2',
    icon: ENV,
    title:
      'SME Identification, Assessment and Management of Risks and Opportunities',
    content: `This module requests information about the procedures that organizations
     have in place to identify, assess, and manage their environmental-related risks and opportunities.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle:
          'SME Identification, Assessment and Management of Risks and Opportunities'
      }
    ],
    route: pillarRoutes.SME_MANAGEMENT
  },

  {
    key: '3',
    icon: SOC,
    title: 'SME Disclosure of Risks and Opportunities',
    content: `This module requests information on risks related to environmental issues, which have had a
     substantive effect on the organization in the reporting year or may in the future, and details of the
      potential effects of those risks and their associated response strategies. It also requests information 
      on any environmental opportunities created by environmental issues which have had a substantive effect
       on the organization in the reporting year or may in the future. `,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'SME Disclosure of Risks and Opportunities'
      }
    ],
    route: pillarRoutes.SME_DISCLOSURE
  },
  {
    key: '4',
    icon: GEN,
    title: 'SME Governance',
    content: `This module requests information on the highest positions or committees with responsibility
     for environmental issues and environmental policies in your organization.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'SME Governance'
      }
    ],
    route: pillarRoutes.SME_GOVERNANCE
  },
  {
    key: '5',
    icon: GOV,
    title: 'SME Business Strategy',
    content: `This module requests information on the effects of risks and opportunities on financial
     and strategic planning, transition plans (a tool for organizations to understand strategic 
     implications of environmental risks and opportunities), and engagement with suppliers, customers,
      and other stakeholders on environmental issues. The module also contains questions on collaborative
       opportunities, shown only to organizations responding to a request from a CDP Supply Chain member. `,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'SME Business Strategy'
      }
    ],
    route: pillarRoutes.BUSINESS_STRATEGY
  },
  {
    key: '6',
    icon: ENV,
    title: 'SME Environmental Performance - Consolidation Approach',
    content: `This module requests information on the method your organization 
    uses to define the boundary for reporting its climate-related impacts, such
     as greenhouse gas (GHG) emissions.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'SME Environmental Performance - Consolidation Approach'
      }
    ],
    route: pillarRoutes.PERFORMANCE_CONSOLIDATION_APPROACH
  },
  {
    key: '7',
    icon: SOC,
    title: 'SME Environmental Performance - Climate Change',
    content: `This module requests information on emissions methodologies, exclusions, 
    emissions inventory and breakdown, energy related activities, targets, and emission 
    reduction activities. The module also contains questions on allocating emissions to
     customers shown only to organizations responding to a request from a CDP Supply Chain member.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'SME Environmental Performance - Climate Change'
      }
    ],
    route: pillarRoutes.PERFORMANCE_CLIMATE_CHANGE
  },
  {
    key: '8',
    icon: GEN,
    title: 'SME Sign Off',
    content: `This module requests information on the verification of the environmental 
    information provided in the organization’s response, and organizational signoff.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'SME Sign Off'
      }
    ],
    route: pillarRoutes.SME_SIGN_OFF
  }
];

export const CDPCorporateObject = [
  {
    key: '1',
    icon: GOV,
    title: 'Corporate Introduction',
    content: `This module requests information about the organization’s 
    disclosure to CDP and will help data users interpret responses in the context of 
    the organization’s business operations, timeframe, and entities included in their CDP response. `,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Corporate Introduction'
      }
    ],
    route: pillarRoutes.CORPORATE_INTRODUCTION
  },
  {
    key: '2',
    icon: GOV,
    title:
      'Corporate Identification, assessment, and management of dependencies, impacts, risks, and opportunities',
    content: `This module requests information about the time horizons at which organizations consider
              environmental issues, how an organization defines what is a substantive effect on its business,
              the procedures that organizations have in place to identify, assess and manage their 
              environmentalrelated dependencies, impacts, risks, and opportunities relevant to their
                sector, and the identification of priority locations. `,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle:
          'Corporate Identification, assessment, and management of dependencies, impacts, risks, and opportunities'
      }
    ],
    route: pillarRoutes.CORPORATE_MANAGEMENT
  },
  {
    key: '3',
    icon: GOV,
    title: 'Corporate Disclosure of Risks and Opportunities',
    content: `This module allows organizations to demonstrate that they have a clear awareness of the extent to
              which they are exposed to environmental risks, and aligned with environmental opportunities, within
              their direct operations and other parts of their value chain.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Corporate Disclosure of Risks and Opportunities'
      }
    ],
    route: pillarRoutes.CORPORATE_DISCLOSURE
  },
  {
    key: '4',
    icon: GOV,
    title: 'Corporate Governance',
    content: `This module requests information on the governance structure of your organization 
    and its governance mechanisms with regards to environmental issues.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Corporate Governance'
      }
    ],
    route: pillarRoutes.CORPORATE_GOVERNANCE
  },
  {
    key: '5',
    icon: GOV,
    title: 'Corporate Business Strategy',
    content: `CDP data users are interested in organizations’ forward-looking strategies, and financial
                    decisions that are driven by future market opportunities, public policy objectives, and
                    corporate responsibilities related to the environment.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Corporate Business Strategy'
      }
    ],
    route: pillarRoutes.CORPORATE_STRATEGY
  },
  {
    key: '6',
    icon: GOV,
    title: 'Corporate Environmental Performance - Consolidation Approach',
    content: `This module requests information on the method used by organizations to define their reporting
                    boundary for environmental performance data, such as greenhouse gas (GHG) emissions, water withdrawals, forest 
                    impacts, plastics, and biodiversity.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Corporate Environmental Performance - Consolidation Approach'
      }
    ],
    route: pillarRoutes.CORPORATE_PERFORMANCE_CONSOLIDATION_APPROACH
  },
  {
    key: '7',
    icon: GOV,
    title: 'Corporate Environmental Performance - Climate Change',
    content: `This module includes questions on emissions methodologies, exclusions, emissions inventory 
                and breakdown, energy related activities, electricity transmission and distribution, production data and 
                intensity & efficiency metrics. `,
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Corporate Environmental Performance - Climate Change'
      }
    ],
    route: pillarRoutes.CORPORATE_PERFORMANCE_CLIMATE_CHANGE
  },
  {
    key: '8',
    icon: GOV,
    title: 'Environmental Performance - Forests',
    content: `This module requests information on your organization’s dependency on commodities,
              and implementation of policies and commitments related to deforestation and conversion of 
              other natural ecosystems.`,
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Environmental Performance - Forests'
      }
    ],
    route: pillarRoutes.CORPORATE_ENVIRONMENTAL_PERFORMANCE_FORESTS
  },
  {
    key: '9',
    icon: GOV,
    title: 'Environmental Performance - Water Security',
    content: `The promotion of water security for all is supported when companies:
          • Reduce their dependency on freshwater sources and track their progress`,
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Environmental Performance - Water Security'
      }
    ],
    route: pillarRoutes.CORPORATE_ENVIRONMENTAL_PERFORMANCE_WATER_SECURITY
  },
  {
    key: '10',
    icon: GOV,
    title: 'Environmental Performance - Plastics',
    content: `Tackling plastic pollution and waste is important for safeguarding our global marine,
          freshwater and terrestrial ecosystems, as well as our economies and communities`,
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Environmental Performance - Plastics'
      }
    ],
    route: pillarRoutes.CORPORATE_ENVIRONMENTAL_PERFORMANCE_PLASTICS
  },
  {
    key: '11',
    icon: GOV,
    title: 'Environmental Performance - Biodiversity',
    content: `The data disclosed in this module will help with the understanding of the 
           interdependence between biodiversity and business resilience`,
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Environmental Performance - Biodiversity'
      }
    ],
    route: pillarRoutes.CORPORATE_ENVIRONMENTAL_PERFORMANCE_BIO_DIVERSITY
  },
  {
    key: '12',
    icon: GOV,
    title: 'Environmental Performance - Financial Services',
    content: `The data disclosed in this module will help with the understanding of the 
           interdependence between biodiversity and business resilience`,
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Environmental Performance - Financial Services'
      }
    ],
    route: pillarRoutes.CORPORATE_ENVIRONMENTAL_PERFORMANCE_FINANCIAL_SERVICES
  },
  {
    key: '13',
    icon: GOV,
    title: 'Further Information And Sign Off',
    content: `Verification and assurance is good practice in environmental 
         reporting as it ensures the quality of data and processes disclosed.`,
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Further Information And Sign Off'
      }
    ],
    route: pillarRoutes.CORPORATE_FURTHER_INFORMATION_AND_SIGN_OFF
  }
];

export const CBAMObject = [
  {
    key: '1',
    icon: CBAM_SECTION1,
    title: 'SECTION 1 — Exporter & Installation Profile',
    content: `Collects legal, organisational, and plant-level details of the exporter and installation.
              Ensures traceability of the manufacturing site, product portfolio, and responsible CBAM contacts.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: '1.1 Exporter Entity Information'
      },
      {
        key: '2',
        ptitle: '1.2 Installation Details'
      },
      {
        key: '3',
        ptitle: '1.3 Product Classification'
      },
      {
        key: '4',
        ptitle: '1.4 Multi-Installation & Multi-Product Mapping'
      }
    ],
    route: pillarRoutes.SECTION_1_EXPORTER_AND_INSTALLATION_PROFILE,
    subCategory: subCategoryConstants.CEMENT_SUB_CATEGORY
  },
  {
    key: '2',
    icon: CBAM_SECTION2,
    title: 'SECTION 2 — Activity Data & Production System Boundary',
    content: `Captures production quantities, raw materials, fuels, and system boundary definitions.
               Provides the foundational activity data required for accurate Scope 1 & Scope 2 emission calculations.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: '2.1 Production Data (Per Product)'
      },
      {
        key: '2',
        ptitle: '2.2 Raw Material Input Data'
      },
      {
        key: '3',
        ptitle: '2.3 Fuel Consumption'
      },
      {
        key: '4',
        ptitle: '2.4 Electricity & Heat Data'
      }
    ],
    route: pillarRoutes.SECTION_2_ACTIVITY_DATA_AND_PRODUCTION_SYSTEM_BOUNDARY,
    subCategory: subCategoryConstants.CEMENT_SUB_CATEGORY
  },
  {
    key: '3',
    icon: CBAM_SECTION3,
    title: 'SECTION 3 — Direct Embedded Emissions (Scope 1)',
    content: `Records all process (calcination), combustion (fuels), and CKD-related emissions from the plant.
              Delivers the plant’s direct CO₂ emissions essential for calculating embedded emissions in CBAM goods.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: '3.1 Process Emissions (Calcination)'
      },
      {
        key: '2',
        ptitle: '3.2 Combustion Emissions (Kiln Fuels)'
      },
      {
        key: '3',
        ptitle: '3.3 Other Process Emissions'
      }
    ],
    route: pillarRoutes.SECTION_3_DIRECT_EMBEDDED_EMISSIONS_SCOPE_1,
    subCategory: subCategoryConstants.CEMENT_SUB_CATEGORY
  },
  {
    key: '4',
    icon: CBAM_SECTION4,
    title: 'SECTION 4 — Indirect Embedded Emissions (Electricity)',
    content: `Captures electricity, captive power, and heat/steam consumption along with emission factors.
            Determines all indirect energy-related emissions that contribute to product-level embedded CO₂.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: '4.1 Purchased Electricity'
      },
      {
        key: '2',
        ptitle: '4.2 Captive Electricity (If any)'
      },
      {
        key: '3',
        ptitle: '4.3 Heat/Steam Consumption'
      }
    ],
    route: pillarRoutes.SECTION_4_INDIRECT_EMBEDDED_EMISSIONS_ELECTRICITY,
    subCategory: subCategoryConstants.CEMENT_SUB_CATEGORY
  },
  {
    key: '5',
    icon: CBAM_SECTION5,
    title: 'SECTION 5 — Precursor Emissions',
    content: `Collects embedded emissions from internal clinker and external precursors (slag, fly ash, etc.).
              Ensures precursor-level CO₂ is properly included in total product emissions as per CBAM rules.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: '5.1 Clinker Used as Precursor in Cement'
      },
      {
        key: '2',
        ptitle: '5.2 External Precursor Inputs'
      }
    ],
    route: pillarRoutes.SECTION_5_PRECURSOR_EMISSIONS,
    subCategory: subCategoryConstants.CEMENT_SUB_CATEGORY
  },
  {
    key: '6',
    icon: CBAM_SECTION6,
    title: 'SECTION 6 — Methodology, Data Quality, Verification',
    content: `Documents selected calculation methods, data quality levels (QL1–QL3), and any third-party verification.
Validates the reliability and compliance of emission data used in CBAM reporting.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: '6.1 Method Selection (Default / Actual / ETS)'
      },
      {
        key: '2',
        ptitle: '6.2 Data Quality Levels (QL1, QL2, QL3)'
      },
      {
        key: '3',
        ptitle: '6.3 Third-Party Verification'
      }
    ],
    route: pillarRoutes.SECTION_6_METHODOLOGY_DATA_QUALITY_VERIFICATION,
    subCategory: subCategoryConstants.CEMENT_SUB_CATEGORY
  },
  {
    key: '7',
    icon: CBAM_SECTION7,
    title: 'SECTION 7 — Emission Summary & Export-Specific Output',
    content: `Generates final product emission intensities and assigns them to EU export batches.
Produces the CBAM-ready output package that EU importers need for their CBAM declaration.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: '7.1 Product-Level Emission Summary'
      },
      {
        key: '2',
        ptitle: '7.2 Export Batch Emission Assignment'
      },
      {
        key: '3',
        ptitle: '7.3 Document Attachments'
      }
    ],
    route: pillarRoutes.SECTION_7_EMISSION_SUMMARY_AND_EXPORT_SPECIFIC_OUTPUT,
    subCategory: subCategoryConstants.CEMENT_SUB_CATEGORY
  }
];

export const CBAMObjectIronAndSteel = [
  {
    key: '1',
    icon: CBAM_SECTION1,
    title: 'SECTION 1 – PLANT & PRODUCTION INFORMATION',
    content: `Captures plant-level identification, location, ownership, and operational details. Establishes 
    clarity on production capacity, operational status, and scope of manufacturing activities carried out at the facility.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Subsection 1.1 – Reporting Period'
      },
      {
        key: '2',
        ptitle: 'Subsection 1.2 – Installation Location'
      },
      {
        key: '3',
        ptitle: 'Subsection 1.3 – Geographic Coordinates'
      },
      {
        key: '4',
        ptitle: 'Subsection 1.4 – Economic Activity'
      },
      {
        key: '5',
        ptitle: 'Subsection 1.5 – Verification'
      },
      {
        key: '6',
        ptitle: 'Subsection 1.6 – Process Setup'
      },
      {
        key: '7',
        ptitle: 'Subsection 1.7 – Precursor Setup'
      },
      {
        key: '8',
        ptitle: 'Subsection 1.8 – Authorized Representative'
      },
      {
        key: '9',
        ptitle: 'Subsection 1.9 – Product & Compliance'
      }
    ],
    route: pillarRoutes.SECTION_1_PLANT_AND_PRODUCTION_INFORMATION,
    subCategory: cbamIronAndSteelSubCategories
  },
  {
    key: '2',
    icon: CBAM_SECTION2,
    title: 'SECTION 2 – SOURCE STREAM & DIRECT EMISSIONS DATA',
    content: `Captures fuel/material source identification, emission calculation methodology, 
      activity data, emission factors, biomass treatment, and carbon quality parameters. Establishes the 
      quantitative basis for calculating CO₂ emissions under CBAM methodology.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Subsection 2.1 – Source Identification'
      },
      {
        key: '2',
        ptitle: 'Subsection 2.2 – Stream Type & Methodology'
      },
      {
        key: '3',
        ptitle: 'Subsection 2.3 – Activity Data'
      },
      {
        key: '4',
        ptitle: 'Subsection 2.4 – Emission Factors'
      },
      {
        key: '5',
        ptitle: 'Subsection 2.5 – Biomass'
      },
      {
        key: '6',
        ptitle: 'Subsection 2.6 – Carbon & Quality'
      }
    ],
    route: pillarRoutes.SECTION_2_SOURCE_STREAM_AND_DIRECT_EMISSIONS_DATA,
    subCategory: cbamIronAndSteelSubCategories
  },
  {
    key: '3',
    icon: CBAM_SECTION3,
    title: 'SECTION 3 – ELECTRICITY & INDIRECT EMISSIONS',
    content: `Captures fuel allocation, monitoring approach, electricity sourcing, emission factor selection, and CHP efficiency parameters.
    Establishes the framework for calculating indirect (Scope 2) emissions and properly allocating fuel use between electricity generation, non-CBAM activities, and exported power.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Subsection 3.1 – Fuel Allocation'
      },
      {
        key: '2',
        ptitle: 'Subsection 3.2 – Monitoring Approach'
      },
      {
        key: '3',
        ptitle: 'Subsection 3.3 – Electricity'
      },
      {
        key: '4',
        ptitle: 'Subsection 3.4 – Emission Factors & CHP'
      }
    ],
    route: pillarRoutes.SECTION_3_ELECTRICITY_AND_INDIRECT_EMISSIONS,
    subCategory: cbamIronAndSteelSubCategories
  },
  {
    key: '4',
    icon: CBAM_SECTION4,
    title: 'SECTION 4 – PROCESS-LEVEL PRODUCTION & EMISSIONS DATA',
    content: `Captures process-level identification, product classification, production volumes, fuel attribution, energy balance, waste gas management, 
      scrap usage, electricity consumption, and carbon capture. Establishes the detailed operational boundaries and embedded emissions calculation at the individual production unit level under CBAM methodology.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Subsection 4.1 – Process Identification'
      },
      {
        key: '2',
        ptitle: 'Subsection 4.2 – Chemical Composition'
      },
      {
        key: '3',
        ptitle: 'Subsection 4.3 – Production'
      },
      {
        key: '4',
        ptitle: 'Subsection 4.4 – Fuel Inputs'
      },
      {
        key: '5',
        ptitle: 'Subsection 4.5 – Energy Balance'
      },
      {
        key: '6',
        ptitle: 'Subsection 4.6 – Waste Gas'
      },
      {
        key: '7',
        ptitle: 'Subsection 4.7 – Scrap & Electricity'
      },
      {
        key: '8',
        ptitle: 'Subsection 4.8 – Carbon Capture'
      }
    ],
    route: pillarRoutes.SECTION_4_PROCESS_LEVEL_PRODUCTION_AND_EMISSIONS_DATA,
    subCategory: cbamIronAndSteelSubCategories
  },
  {
    key: '5',
    icon: CBAM_SECTION5,
    title: 'SECTION 5 – PRECURSOR (PURCHASED INPUT) EMISSIONS DATA',
    content: `Captures identification, origin, embedded emissions, data source, and process linkage of purchased CBAM precursors.
       Establishes the calculation of embedded emissions from imported semi-finished materials and ensures correct attribution to production processes under CBAM rules.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Subsection 5.1 – Precursor Identification'
      },
      {
        key: '2',
        ptitle: 'Subsection 5.2 – Origin'
      },
      {
        key: '3',
        ptitle: 'Subsection 5.3 – Emissions'
      },
      {
        key: '4',
        ptitle: 'Subsection 5.4 – Data Verification'
      }
    ],
    route: pillarRoutes.SECTION_5_PRECURSOR_PURCHASED_INPUT_EMISSIONS_DATA,
    subCategory: cbamIronAndSteelSubCategories
  },
  {
    key: '6',
    icon: CBAM_SECTION6,
    title: 'SECTION 6 – CARBON PRICING & TAX ADJUSTMENT',
    content: `Captures information on carbon price paid in the country of origin, including legal basis, payment details, emissions coverage, and 
    supporting documentation. Establishes eligibility for CBAM carbon price deductions and ensures proper financial adjustment against EU CBAM obligations.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Subsection 6.1 – Carbon Tax Status'
      },
      {
        key: '2',
        ptitle: 'Subsection 6.2 – Tax Details'
      },
      {
        key: '3',
        ptitle: 'Subsection 6.3 – Payment'
      },
      {
        key: '4',
        ptitle: 'Subsection 6.4 – Coverage & Proof'
      }
    ],
    route: pillarRoutes.SECTION_6_CARBON_PRICING_AND_TAX_ADJUSTMENT,
    subCategory: cbamIronAndSteelSubCategories
  },
  {
    key: '7',
    icon: CBAM_SECTION7,
    title: 'SECTION 7 – SHIPMENT & CUSTOMS INFORMATION',
    content: `Captures shipment-level identification, invoice linkage, and logistics details required for customs traceability. 
    Establishes the connection between CBAM declarations, commercial documentation, and physical movement of goods into the EU.`,
    buttonText: 'Continue',
    mods: MODS,
    ques: QUES,
    modules: 'No. of Modules',
    questions: 'Question Answered',
    timel: [
      {
        key: '1',
        ptitle: 'Subsection 7.1 – Shipment Identification'
      },
      {
        key: '2',
        ptitle: 'Subsection 7.2 – Logistics'
      }
    ],
    route: pillarRoutes.SECTION_7_SHIPMENT_AND_CUSTOMS_INFORMATION,
    subCategory: cbamIronAndSteelSubCategories
  }
];
